import React from 'react'

interface Props {
  width?: string
  height?: string
  fill?: string
}

const IconRocket = ({ width = '24px', height = '24px', fill = '#000' }: Props) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 24 24'>
      <g>
        <path
          fill={fill}
          d='M7.354,16.644a2.212,2.212,0,0,0-1.512-.665,2.221,2.221,0,0,0-1.595.665c-.788.787-1.579,3.658-1.73,4.225A.5.5,0,0,0,3,21.5a.479.479,0,0,0,.119-.015c.544-.133,3.3-.836,4.089-1.627A2.281,2.281,0,0,0,7.354,16.644Z'
        />
        <path
          fill={fill}
          d='M9.26,6.79a12.716,12.716,0,0,0-2.84,6.04l-3.32.66a.34.34,0,0,1-.1.01.465.465,0,0,1-.38-.18.5.5,0,0,1-.08-.51l.96-2.39A5.465,5.465,0,0,1,7.7,7.05Z'
        />
        <path
          fill={fill}
          d='M17.21,14.74l-.26,1.56a5.488,5.488,0,0,1-3.38,4.21l-2.38.95a.433.433,0,0,1-.19.04.49.49,0,0,1-.32-.12.484.484,0,0,1-.17-.48l.66-3.32A12.716,12.716,0,0,0,17.21,14.74Z'
        />
        <path
          fill={fill}
          opacity={0.3}
          d='M21,2.25c-8.1,0-13.429,3.96-14.626,10.865a2.23,2.23,0,0,0,.635,1.954l1.922,1.923a2.255,2.255,0,0,0,1.588.666,2.146,2.146,0,0,0,.366-.032C17.79,16.429,21.75,11.1,21.75,3A.75.75,0,0,0,21,2.25Zm-10.371,13.9a.75.75,0,0,1-.638-.217L8.069,14.008a.738.738,0,0,1-.217-.637h0a10.506,10.506,0,0,1,6.453-8.34A4.977,4.977,0,0,1,18.969,9.7,10.506,10.506,0,0,1,10.629,16.148Z'
        />
        <circle fill={fill} cx='13.5' cy='10.5' r='2.25' />
      </g>
    </svg>
  )
}

export default IconRocket
